import { render, staticRenderFns } from "./Residentials.vue?vue&type=template&id=258e176a&scoped=true&lang=pug&"
import script from "./Residentials.vue?vue&type=script&lang=js&"
export * from "./Residentials.vue?vue&type=script&lang=js&"
import style0 from "./Residentials.vue?vue&type=style&index=0&id=258e176a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258e176a",
  null
  
)

export default component.exports